import { z } from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_periodontal_disease = (params: StepConfigParams) => {
  return {
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('treated_peridontal_disease_3_years')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_periodontal_disease.title',
        },
      },
      {
        type: 'yesNo',
        variant: 'filled',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('treated_peridontal_disease_3_years'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('treated_peridontal_disease_3_years'),
      valueToStepName: {
        true: 'failure',
        false: 'dental_quote',
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default dental_periodontal_disease
